var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "prop-types", "emotion-theming", "../Button/Button", "../Icon/Icon", "./NextSubscribe.css", "../../css"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"), require("emotion-theming"), require("../Button/Button"), require("../Icon/Icon"), require("./NextSubscribe.css"), require("../../css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.emotionTheming, global.Button, global.Icon, global.NextSubscribe, global.css);
    global.NextSubscribe = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _propTypes, _emotionTheming, _Button, _Icon, _NextSubscribe, _css) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _Button = _interopRequireDefault(_Button);
  _Icon = _interopRequireDefault(_Icon);
  var themes = {
    dark: {
      backgroundColor: (0, _css.palette)('primary', 'mainNav'),
      borderTop: "".concat((0, _css.remCalc)(10), " solid ").concat((0, _css.palette)('primary', 'mainNav'))
    },
    light: {
      backgroundColor: (0, _css.palette)('primary', 'mainDivider'),
      borderTop: "".concat((0, _css.remCalc)(10), " solid ").concat((0, _css.palette)('primary', 'mainDivider'))
    }
  };

  var NextSubscribe = function NextSubscribe(_ref) {
    var isActive = _ref.isActive,
        labels = _ref.labels,
        onToggleSubscribe = _ref.onToggleSubscribe,
        theme = _ref.theme;

    var onClick = function onClick() {
      onToggleSubscribe(!isActive);
    };

    return /*#__PURE__*/_react.default.createElement(_emotionTheming.ThemeProvider, {
      theme: themes[theme] || themes.dark
    }, /*#__PURE__*/_react.default.createElement(_NextSubscribe.StyledSubscribe, {
      className: "next-subscribe"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      icon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
        name: isActive ? 'arte-next-subscribed' : 'arte-next-subscribe',
        size: "small"
      }),
      label: isActive ? labels.subscribed : labels.subscribe,
      onClick: onClick,
      type: "button",
      className: "next-button--outline"
    })));
  };

  NextSubscribe.propTypes = {
    isActive: _propTypes.default.bool,
    labels: _propTypes.default.shape({
      subscribe: _propTypes.default.string,
      subscribed: _propTypes.default.string
    }),
    onToggleSubscribe: _propTypes.default.func.isRequired,
    theme: _propTypes.default.oneOf(['dark', 'light'])
  };
  NextSubscribe.defaultProps = {
    isActive: false,
    labels: {
      subscribe: 'Subscribe',
      subscribed: 'Subscribed'
    },
    // eslint-disable-next-line no-unused-vars
    onToggleSubscribe:
    /** @param subscribe subscribe state requested */
    function onToggleSubscribe(subscribe) {},
    theme: 'dark'
  };
  var _default = NextSubscribe;
  _exports.default = _default;
});